export default (that) => [

  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    slots: {
      default: 'opt'
    }
  },
  {
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.order_goods_label_expand') || '展开',
    slots: {
      content: 'expandContent'
    },
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    minWidth: 150,
    align: 'center',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_goods_label_qty') || '数量',
    field: 'qty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.goods_label_isGroup') || '是否套装',
    field: 'v_isGroup',
    minWidth: 80,
    align: 'center',
    slots: { default: 'isGroup' }
  },
  {
    title: that.$l('INDEX.order_goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    minWidth: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_boxQty') || '箱数',
    field: 'boxQty',
    minWidth: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_price') || '成本价',
    field: 'price',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_subAmount') || '成本小计',
    field: 'v_subAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_salePrice') || '售价',
    field: 'salePrice',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_subSaleAmount') || '售价小计',
    field: 'v_saleSubAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_netSalePrice') || '去佣金后单价',
    field: 'netSalePrice',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_subNetSalePrice') || '去佣金后小计',
    field: 'v_subNetSalePrice',
    minWidth: 120,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
  },
]
